import { Injectable, signal } from '@angular/core';
import type { PushNotificationSchema } from '@capacitor/push-notifications';
import { resolveNotificationRoute } from '../navigation/route-normalization.util';

export interface InAppNotification {
  title: string;
  body: string;
  deepLink: string;
}

@Injectable({
  providedIn: 'root'
})
export class InAppNotificationService {
  readonly current = signal<InAppNotification | null>(null);

  private dismissTimeoutId: ReturnType<typeof setTimeout> | null = null;

  showFromPush(notification: PushNotificationSchema): void {
    const payload = notification.data as Record<string, unknown> | undefined;
    const deepLink = resolveNotificationRoute(payload);
    this.show({
      title: notification.title ?? '',
      body: notification.body ?? '',
      deepLink,
    });
  }

  show(notification: InAppNotification): void {
    this.current.set(notification);
    this.scheduleDismiss();
  }

  dismiss(): void {
    this.current.set(null);
    if (this.dismissTimeoutId !== null) {
      clearTimeout(this.dismissTimeoutId);
      this.dismissTimeoutId = null;
    }
  }

  private scheduleDismiss(): void {
    if (this.dismissTimeoutId !== null) {
      clearTimeout(this.dismissTimeoutId);
    }
    this.dismissTimeoutId = setTimeout(() => {
      this.current.set(null);
      this.dismissTimeoutId = null;
    }, 6000);
  }

}
